import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {OphSkipDialogContentComponent} from 'src/app/shared/dialog/oph-skip-dialog-content/oph-skip-dialog-content.component';

@Component({
  selector: 'current-sked-skip-confirmation-dialog',
  standalone: true,
  imports: [OphSkipDialogContentComponent],
  templateUrl: './current-sked-skip-confirmation-dialog.component.html',
  styleUrl: './current-sked-skip-confirmation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentSkedSkipConfirmationDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<CurrentSkedSkipConfirmationDialogComponent>);

  message = 'Are you sure you want to skip this task?';
  loading = signal(false);

  onClose(skipTask: boolean) {
    if (skipTask) {
      this.loading.set(true);
      this.dialogRef.close(true);
    } else {
      this.dialogRef.close(false);
    }
  }
}
